import request from "@/utils/request";
export function fetchList(data) {
  return request({
    url: "/whg-park/api/activeManage/list",
    method: "post",
    data: data
  });
} // 添加

export function fetchCreate(data) {
  return request({
    url: "/whg-park/api/activeManage/insert",
    method: "post",
    data: data
  });
} // 删除

export function fetchDelete(data) {
  return request({
    url: "/whg-park/api/activeManage/delete",
    method: "post",
    data: data
  });
} // 编辑

export function fetchUpdate(data) {
  return request({
    url: "/whg-park/api/activeManage/update",
    method: "post",
    data: data
  });
} // 详情

export function fetchDetail(data) {
  return request({
    url: "/whg-park/api/activeManage/get",
    method: "post",
    data: data
  });
} // 发布活动

export function fetchPublish(data) {
  return request({
    url: "/whg-park/api/activeManage/isPublish",
    method: "post",
    data: data
  });
} // 下架活动

export function fetchActiOffline(data) {
  return request({
    url: "/whg-park/api/activeManage/actiOffline",
    method: "post",
    data: data
  });
} // 审核活动

export function fetchAudit(data) {
  return request({
    url: "/whg-park/api/approval/approval",
    method: "post",
    data: data
  });
} // 活动成果上传

export function fetchActiveUpload(data) {
  return request({
    url: "/whg-park/api/activeManage/upload",
    method: "post",
    data: data
  });
} // 活动成果查看

export function fetchActiveGet(data) {
  return request({
    url: "/whg-park/api/activeManage/getUpload",
    method: "post",
    data: data
  });
}